const initializeMobileMenus = () => {
  document.querySelectorAll('#header-component.tbm-header [data-tbb-menu]').forEach(menu => {
    if (menu.dataset.tbmReady) return;
    menu.dataset.tbmReady = 'true';
    const summary = menu.querySelector('summary');
    const close = restoreFocus => {
      if (!menu.open) return;
      menu.open = false;
      summary.setAttribute('aria-expanded', 'false');
      if (restoreFocus) summary.focus({ preventScroll: true });
    };
    menu.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(menu.open)));
    menu.addEventListener('keydown', event => {
      if (event.key === 'Escape' && menu.open) { event.preventDefault(); close(true); }
    });
    menu.addEventListener('focusout', () => {
      requestAnimationFrame(() => { if (!menu.contains(document.activeElement)) close(false); });
    });
    menu.addEventListener('click', event => {
      if (event.target.closest('a')) close(false);
    });
    document.addEventListener('pointerdown', event => {
      if (menu.open && !menu.contains(event.target)) close(false);
    });
    matchMedia('(min-width:750px)').addEventListener('change', event => { if (event.matches) close(false); });
  });
};
initializeMobileMenus();
document.addEventListener('shopify:section:load', initializeMobileMenus);

